module.exports = __webpack_public_path__ + "img/notifications/edge-notifications-blocked-c660adb89dedf05b33cd931cfdfe26bf.png";